// Shared algorithm constants
export const WEIGHT_COST = 5;
